import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";
import TeamInvitationSelfServeSignUpContainer from "../containers/TeamInvitationSelfServeSignUpContainer";

const TeamInvitationSignUpSelfServePage = () => {
  return (
    <UnderMaintenanceOrChildren>
      <TeamInvitationSelfServeSignUpContainer />
    </UnderMaintenanceOrChildren>
  );
};

export default TeamInvitationSignUpSelfServePage;
